<!--
 - Order custom tab component HTML
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2024 Build Centrix
 -->
<bc-templates-modal-layout
  [isLoading]="false"
  [loadingText]="('actions.loading'|translate)"
  (onCloseButtonClicked)="onDismiss()"
>
  <!--Dialog Title-->
  <div title-content>
    <span *ngIf="!isEditMode">{{ 'actions.add'|translate }} </span>
    <span *ngIf="isEditMode">{{ 'actions.edit'|translate }} </span>
    <span>{{'order.tabs.custom.title.singular'|translate }}</span>
  </div>
  <!--Dialog Subtitle-->
  <div subtitle-content>
    {{'order.tabs.custom.description'|translate: { min: customTabColumnsMin,
    max: customTabColumnsMax } }}
  </div>
  <!--Dialog Content-->
  <div body-content>
    <form #customTabForm="ngForm">
      <!--Layout-->
      <div class="row">
        <div class="col">
          <bc-atoms-input-group
            labelTitle="{{'order.tabs.custom.fields.label.title'|translate: { max: customTabLabelMaxLength } }}"
            labelDescription="{{'order.tabs.custom.fields.label.description'|translate: { max: customTabLabelMaxLength } }}"
            [required]="true"
            [state]="tabLabelControl.status"
            [stateInput]="tabLabelControl.errors"
            [stateTrigger]="tabLabelControl.invalid && (tabLabelControl.touched && tabLabelControl.dirty)"
          >
            <bc-atoms-input
              id="tabLabel"
              name="tabLabel"
              title="{{'order.tabs.custom.fields.label.description'|translate: { max: customTabLabelMaxLength } }}"
              placeholder="{{'order.tabs.custom.fields.label.title'|translate: { max: customTabLabelMaxLength } }}"
              [minlength]="0"
              [maxlength]="customTabLabelMaxLength"
              [required]="true"
              [(model)]="customTabLabel"
              [(ngModel)]="customTabLabel"
              #tabLabelControl="ngModel"
            ></bc-atoms-input>
          </bc-atoms-input-group>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ul class="custom-tab-columns">
            <li *ngFor="let column of customTabColumnOptions">
              <bc-atoms-checkbox
                *ngIf="column.canToggle"
                [label]="column.label"
                [disabled]="!column.selected && (customTabColumnsSelected === customTabColumnsMax)"
                [title]="column.description"
                [(model)]="column.selected"
                (onCheckboxClicked)="setCustomColumnsCount()"
              >
              </bc-atoms-checkbox>
            </li>
          </ul>
        </div>
      </div>
    </form>
  </div>
  <!--Dialog Actions-->
  <div footer-content>
    <div class="buttons-container">
      <div class="left-buttons" *ngIf="isEditMode">
        <!--Delete-->
        <bc-atoms-button
          id="btnCustomTabDelete"
          icon="delete"
          label="{{'order.tabs.custom.delete.title'|translate:{key:wdOrdersService.orderViewSettings.selectedTab.label} }}"
          title="{{'order.tabs.custom.delete.description'|translate:{key:wdOrdersService.orderViewSettings.selectedTab.label}  }}"
          display="block"
          size="small"
          type="linkDanger"
          [disabled]="!canDelete"
          [confirmTitle]="'actions.removeType'| translate: { type: 'order.tabs.custom.title.singular' | translate }"
          (onButtonClicked)="onDelete()"
        >
          <div confirmation-body>
            <div>
              {{ 'prompts.confirmDeleteType' | translate: { type:
              wdOrdersService.orderViewSettings.selectedTab.label } }}
            </div>
          </div>
        </bc-atoms-button>
      </div>
      <div class="right-buttons">
        <!--Cancel/Close -->
        <bc-atoms-button
          [label]="('actions.close'|translate)"
          [title]="('actions.close'|translate)"
          type="default"
          icon="close"
          display="block"
          size="small"
          (onButtonClicked)="onDismiss()"
        >
        </bc-atoms-button>
        <!--Save -->
        <bc-atoms-button
          [label]="('actions.save'|translate)"
          [title]="('actions.save'|translate)"
          type="success"
          icon="ok"
          [disabled]="!customTabForm.form.valid || (customTabColumnsSelected < customTabColumnsMin) || (customTabColumnsSelected > customTabColumnsMax)"
          display="block"
          size="small"
          (onButtonClicked)="onSave()"
        >
        </bc-atoms-button>
      </div>
    </div>
  </div>
</bc-templates-modal-layout>
